"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("styled-components");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .calculator__button {\n    padding: 15px 12px;\n    text-decoration: none;\n    border: none;\n    border-radius: 50px;\n\n    font-size: 17px;\n    line-height: 26px;\n    font-weight: 500;\n\n    background-color: #262626;\n    color: #fff;\n\n    cursor: pointer;\n    \n    &_square {\n      display: inline-block;\n      border-radius: 4px;\n    }\n\n    &:hover {\n      text-decoration: none;\n      background-color: #18bb4f;\n      outline: none;\n    }\n\n    &:focus {\n      text-decoration: none;\n      background-color: #15a144;\n      outline: none;\n    }\n\n    @media screen and (min-width: 768px) {\n      padding: 15px 32px;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ButtonStyles = (0, _styledComponents.css)(_templateObject());
var _default = ButtonStyles;
exports.default = _default;